
/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// GETALLSTAKENOWSECTIONSBYSECTIONNAMEBASEDONCREATOR
// GETALLSTAKENOWSECTIONSBYSECTIONNAMEBASEDONCREATOR


const GETALLSTAKENOWSECTIONSBYSECTIONNAMEBASEDONCREATOR= createAsyncThunk(
  "getAllStakeNowSectionsBySectionNameBasedOnCreator/getAllStakeNowSectionsBySectionNameBasedOnCreator",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllStakeNowSectionsBySectionNameBasedOnCreatorSlice = createSlice({
  name: "getAllStakeNowSectionsBySectionNameBasedOnCreatorSlice",
  initialState: {
    getAllStakeNowSectionsBySectionNameBasedOnCreator: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllStakeNowSectionsBySectionNameBasedOnCreator: (state) => {
        state.getAllStakeNowSectionsBySectionNameBasedOnCreator.loading = false
        state.getAllStakeNowSectionsBySectionNameBasedOnCreator.error = false
        state.getAllStakeNowSectionsBySectionNameBasedOnCreator.data = []
        state.getAllStakeNowSectionsBySectionNameBasedOnCreator.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLSTAKENOWSECTIONSBYSECTIONNAMEBASEDONCREATOR.fulfilled, (state, action) => {
      state.getAllStakeNowSectionsBySectionNameBasedOnCreator = {
        ...state.getAllStakeNowSectionsBySectionNameBasedOnCreator,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLSTAKENOWSECTIONSBYSECTIONNAMEBASEDONCREATOR.pending, (state, action) => {
      state.getAllStakeNowSectionsBySectionNameBasedOnCreator = {
        ...state.getAllStakeNowSectionsBySectionNameBasedOnCreator,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLSTAKENOWSECTIONSBYSECTIONNAMEBASEDONCREATOR.rejected, (state, action) => {
      state.getAllStakeNowSectionsBySectionNameBasedOnCreator = {
        ...state.getAllStakeNowSectionsBySectionNameBasedOnCreator,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllStakeNowSectionsBySectionNameBasedOnCreatorAction = {
    GETALLSTAKENOWSECTIONSBYSECTIONNAMEBASEDONCREATOR,
};

export { getAllStakeNowSectionsBySectionNameBasedOnCreatorAction };
export default getAllStakeNowSectionsBySectionNameBasedOnCreatorSlice.reducer;
export const {setInitialStateOfgetAllStakeNowSectionsBySectionNameBasedOnCreator} = getAllStakeNowSectionsBySectionNameBasedOnCreatorSlice.actions
